import { LoaderNotifier } from '@/components/Loader'
import { Notifications } from '@/components/Notification'
import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { Footer } from './Footer'
import { Navbar } from './Navbar'

export const MainLayout = () => {
  return (
    <>
      <Navbar />
      <Notifications />
      <main className="w-full overflow-hidden">
        <Suspense fallback={<LoaderNotifier />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </>
  )
}
